// extracted by mini-css-extract-plugin
module.exports = {"departmentsNav":"Styles_departmentsNav__2YIC0"};